<button
    (click)="toggle()"
    [disabled]="disabled"
    *ngIf="selectedOption$ | async as option"
    [ngbTooltip]="option.label"
    container="body"
>
    <fa-icon *ngIf="option.icon" [icon]="option.icon"></fa-icon>
</button>
